import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { VamTitularEntity } from '../../../vam/titulares/entities/vam_titulares_entity';
import { ListadosServices } from './listados.service';
import { DependientesVam } from '../../../vam/vam_entity';
import { forEach } from '@angular/router/src/utils/collection';
import { ClienteLogin } from '../../../login/cliente_login';
import { SessionStorageService } from 'ngx-webstorage';
import { UtilService } from '../../../../components/common/utils/util.service';

const swal = require("sweetalert2");
declare var jQuery: any;



@Component({
    selector: 'listadosTitulares',
    templateUrl: 'listados.template.html'
})

export class ListadosComponent implements OnChanges, OnInit {
    @Input() polizaContratada: PolizaEntity;
    listados: VamTitularEntity[];
    listaDep: DependientesVam[];
    showLoader: string;
    usuario: ClienteLogin;
    bandera: boolean;
    filterQuery1: string;
    filterQuery2: string;
    filterQuery3: string;
    categorias: string[];

    constructor(private route: ActivatedRoute,
        private router: Router, private handleError: HandleError,
        public listadosService: ListadosServices,
        public sesionStorageService: SessionStorageService, public utilsService: UtilService) {
            this.bandera = false;
        }

    ngOnInit(){
        this.listados = new Array<VamTitularEntity>();
        this.bandera = false;
    }

    ngOnChanges() {
        this.bandera = false;
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        this.listados = new Array<VamTitularEntity>();
        this.listaDep = new Array<DependientesVam>();
        this.showLoader = "sk-loading";

        this.listadosService.ConsultarListadosPorPoliza(this.polizaContratada).subscribe(
            result => {
                this.listados = result;
                if(this.listados.length > 0){
                    this.bandera = true;
                    let categorias = result.map(function (obj) { return obj.Categoria; });
                    this.categorias = categorias.filter(function (v, i) { return categorias.indexOf(v) == i; });
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
                this.showLoader = "";
            }
        );
    }

    ExportarTitulares(listado: VamTitularEntity[]) {
        this.listadosService.ExportarListado(listado)
            .subscribe(result => {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.className = "hidden"
                let fileBlob = result.blob();
                let blob = new Blob([fileBlob], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = "listados.xlsx";
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, "Listado.xlsx");
                }
                else {
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
                this.showLoader = "";
            }, error => this.handleError.redirectUrl(error));
    }




}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/listados/listados.component.ts